import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IGenericCrudConfiguration } from 'src/app/libs/components/generic-crud/generic-crud.component';
import {Checkpoint, ECheckpointDataType} from 'src/app/models';
import { MasterApiService } from 'src/app/services/master-api.service';
import { CheckpointsAddComponent } from './checkpoints-add/checkpoints-add.component';
import { CheckpointsEditComponent } from './checkpoints-edit/checkpoints-edit.component';
import { checkpointDataTypeSelectItems } from './checkpoint-data-type-items';
import {firstValueFrom} from "rxjs";

@Component({
  selector: 'app-checkpoints',
  templateUrl: './checkpoints.component.html',
  styleUrl: './checkpoints.component.sass',
  standalone: false,
})
export class CheckpointsComponent implements OnInit {
  config?: IGenericCrudConfiguration<Checkpoint>;
  sensorsTypesResource = this.api.resources.sensorTypes;

  constructor(
    private api: MasterApiService,
    private tr: TranslateService
  ) {}

  async ngOnInit(): Promise<void> {
    const sensors = await firstValueFrom(this.sensorsTypesResource.getAll());
    const dataTypes = checkpointDataTypeSelectItems(this.tr);

    this.config = {
      name: this.api.resources.checkpoints.resourceName,
      resource: this.api.resources.checkpoints,
      editComponent: CheckpointsEditComponent,
      createComponent: CheckpointsAddComponent,
      entityFields: {
        companyId: { visible: false },
        name: { caption:'common.name', isLink: true },
        dataTypeId: {
          lookup: {
            dataSource: dataTypes,
            displayExpr: 'name',
            valueExpr: 'id',
          },
        },
        values: {
          calculateCellValue: (row: Checkpoint) => {
            if (!Array.isArray(row.values) || row.values.length === 0) return '';

            if (row.dataTypeId === ECheckpointDataType.Sensor) {
              const sensorId = row.values[0];
              const sensor = sensors.find(s => s.id === sensorId);
              return sensor?.name ?? sensorId ?? '';
            }

            return row.values.join(', ');
          },
        },
      },
      crudButtons: {
        canCreate: true,
        canEdit: true,
        canDelete: true,
        canCopy: false,
      },
    };
  }
}
